import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type GetAllTransactionsResponse } from '@shared/api';

interface UseAllTransactionsStore {
  loading: boolean;
  data: GetAllTransactionsResponse[];
  error: string | null;
  getAllTransactions: (id: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAllTransactionsStore = create<UseAllTransactionsStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getAllTransactions: ApiUtils.wrapperApi(async (id, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountsApi.getAllTransactions(id, signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
